import React from "react";
import style from "./QuestionHeader.module.scss";
import moment from "moment";

export default function QuestionHeader({
    title,
    studentName,
    addtime
}: {
    title: string;
    studentName: string;
    addtime: string;
}) {
    return (
        <div className={style.root}>
            <h1 className={style.title}>{title}</h1>
            <p className={style.info}>
                {" "}
                {studentName}
                {addtime && (
                    <span className={style.time}>
                        {moment
                            .unix(parseInt(addtime.split(".")[0]))
                            .format("MM-DD HH:mm")}
                    </span>
                )}
            </p>
        </div>
    );
}
